import {
  ISettingsForm,
  ISettingsMutation,
} from 'services/settings/application/types';
import { DOCUMENT_NUMERATION_TYPE } from 'services/types';

export const applicationFormToMutation = (
  form: ISettingsForm
): ISettingsMutation => ({
  ...form,
  isrcStartNumber: form.isrcStartNumber ?? 0,
  isrcGenerationStartDate: form.isrcGenerationStartDate?.length
    ? new Date(form.isrcGenerationStartDate).toISOString()
    : null,
  remainingEansNotificationThreshold:
    Number(form.remainingEansNotificationThreshold) || 0,
  contractEmailConfiguration: form.contractEmailConfiguration ?? null,
  labelReportEmailConfiguration: form.labelReportEmailConfiguration ?? null,
  settlementEmailConfiguration: form.settlementEmailConfiguration ?? null,
  currentTheme: form.currentTheme ?? null,
  documentsConfiguration: {
    ...form.documentsConfiguration,
    trackReportShortcut: form.documentsConfiguration.trackReportShortcut ?? '',
    trackReportNumerationType:
      form.documentsConfiguration.trackReportNumerationType ??
      DOCUMENT_NUMERATION_TYPE.unknown,
  },
});
